import { lazy, Suspense } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ProgressBar from 'react-topbar-progress-indicator';
import { alpha, useTheme } from '@mui/material/styles';

// auth screens
import PortraitBase from 'components/OrientedLayouts/Portrait';
import LandscapeBase from 'components/OrientedLayouts/Landscape';
import Otp from 'components/Otp';

// templates
import DefaultTemplate from 'templates/DefaultTemplate';

/**
 * @component Routes
 */
function AppRoutes() {
  // const setNavigationOpen = useNavigationDrawerSetState();
  // const navigate = useNavigate();
  const theme = useTheme();
  // navigate.listen(() => {
  //   // setNavigationOpen(false);
  //   window.scrollTo(0, 0);
  // });
  ProgressBar.config({
    barColors: {
      0: alpha(theme?.palette?.primary?.main, 0.7),
      '1.0': theme?.palette?.primary?.main,
    },
    shadowBlur: 5,
  });

  return (
    <Routes>
      {/* Authentication Routes */}
      <Route path="/auth" element={<Otp />} />
      <Route path="/por" element={<PortraitBase />} />
      <Route path="/" element={<LandscapeBase />} />

      <Route
        path="*"
        element={
          <DefaultTemplate>
            <Suspense fallback={<ProgressBar />}>
              {/* Nested routes can be defined here if necessary */}
              <Routes>
                {/* Example of nested route */}
                {/* <Route path="example" element={<ExampleComponent />} /> */}
              </Routes>
            </Suspense>
          </DefaultTemplate>
        }
      />
    </Routes>
  );
}

export default AppRoutes;
